export var LogType;
(function (LogType) {
    LogType[LogType["default"] = 14] = "default";
    LogType[LogType["owl"] = 15] = "owl";
    LogType[LogType["redux"] = 16] = "redux";
    LogType[LogType["vuex"] = 17] = "vuex";
    LogType[LogType["zaku"] = 22] = "zaku";
    LogType[LogType["archer"] = 25] = "archer";
    LogType[LogType["mtgame"] = 30] = "mtgame";
    LogType[LogType["tracker"] = 31] = "tracker";
    LogType[LogType["hotdog"] = 37] = "hotdog";
    LogType[LogType["diting"] = 41] = "diting";
})(LogType || (LogType = {}));
